import { DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { PropertyExposeService } from 'landlord/main/screens/properties/services/properties-expose.service';
import { AttachmentService, HierarchicalQuestionService } from '@ui/legacy-lib';
import { ConsumptionService } from 'landlord/screens/account';
import {
  CustomQuestionResponsesFacade,
  InternalListFacade,
  PropertySearcherFacade
} from '@ui/landlord/shared/facade';
import { effects, reducers } from './+state';
import { MessengerGuard, SimplePropertiesGuard } from './guards';
import {
  AsyncValidatorsService,
  AutomatedRentalFacade,
  AutomatedRentalService,
  DashboardFacade,
  DigitalContractFacade,
  ObjectNoteFacade,
  ProjectsFacade,
  PropertiesFacade,
  PropertiesGqlService,
  PropertySearcherHistoryFacade,
  PropertySearcherService,
  UviControlFacade
} from './services';
import { LegalFacade } from './services/legal.facade';

const providers = [
  NgbActiveModal,
  PropertiesFacade,
  CustomQuestionResponsesFacade,
  PropertySearcherHistoryFacade,
  PropertiesGqlService,
  SimplePropertiesGuard,
  MessengerGuard,
  PropertyExposeService,
  DigitalContractFacade,
  DashboardFacade,
  AsyncValidatorsService,
  PropertySearcherService,
  InternalListFacade,
  AutomatedRentalFacade,
  AutomatedRentalService,
  DecimalPipe,
  ObjectNoteFacade,
  AttachmentService,
  ProjectsFacade,
  LegalFacade,
  UviControlFacade,
  ConsumptionService,
  HierarchicalQuestionService,
  PropertySearcherFacade
];

@NgModule({
  providers: [
    ...providers,
    provideState('MainState', reducers),
    provideEffects(effects)
  ]
})
export class MainModule {}
